document.documentElement.classList.add('js');

// .product-info scrolls independently of the page at desktop widths --
// browsers sometimes restore or shift a scrollable container's own
// scroll position (scroll anchoring, history restoration) independent of
// the page itself, which can leave it starting mid-content instead of at
// the product title. Force it to the top on every load.
document.querySelectorAll('.product-info').forEach(function (el) { el.scrollTop = 0; });

document.addEventListener('click', function (e) {
  var playBtn = e.target.closest('.video-card__play');
  if (!playBtn || playBtn.disabled) return;
  var card = playBtn.closest('.video-card');
  var videoId = card && card.dataset.videoId;
  if (!videoId) return;
  var iframe = document.createElement('iframe');
  iframe.src = 'https://www.tiktok.com/embed/v2/' + videoId + '?autoplay=1';
  iframe.className = 'video-card__frame';
  iframe.allow = 'autoplay; encrypted-media; fullscreen';
  iframe.setAttribute('allowfullscreen', '');
  iframe.loading = 'lazy';
  iframe.title = 'TikTok video';
  playBtn.replaceWith(iframe);
});

function initScrollTracking(root, trackSelector, itemSelector, dotSelectors) {
  var track = root.querySelector(trackSelector);
  var items = track ? track.querySelectorAll(itemSelector) : [];
  if (!items.length) return;
  var dotGroups = dotSelectors
    .map(function (sel) { return root.querySelectorAll(sel); })
    .filter(function (group) { return group.length; });
  if (!dotGroups.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
      var index = Array.prototype.indexOf.call(items, entry.target);
      dotGroups.forEach(function (group) {
        group.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      });
    });
  }, { root: track, threshold: [0.6] });
  items.forEach(function (item) { observer.observe(item); });
}

// Desktop (>=900px): thumbnails overlay the main image and switch it
// instantly on hover, click, or keyboard focus -- no scrolling involved,
// so the scroll-position-based tracker below doesn't apply here.
function initGalleryHoverSwitch(gallery) {
  var track = gallery.querySelector('.product-gallery__track');
  var items = track ? Array.prototype.slice.call(track.querySelectorAll('.product-gallery__item')) : [];
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
  if (!items.length || !thumbs.length) return;

  function setActive(index) {
    items.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
    thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('mouseenter', function () { setActive(i); });
    thumb.addEventListener('click', function (e) { e.preventDefault(); setActive(i); });
    thumb.addEventListener('focus', function () { setActive(i); });
  });

  if (!items.some(function (item) { return item.classList.contains('is-active'); })) {
    setActive(0);
  }
}

document.querySelectorAll('.product-gallery').forEach(function (gallery) {
  if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches) {
    initGalleryHoverSwitch(gallery);
  } else {
    initScrollTracking(gallery, '.product-gallery__track', '.product-gallery__item', ['.product-gallery__dot', '.product-gallery__thumb']);
  }
});

document.querySelectorAll('.product-scroll').forEach(function (scroll) {
  initScrollTracking(scroll, '.product-scroll__track', '.product-scroll__card', ['.product-scroll__dot']);
});

document.addEventListener('click', function (e) {
  var dismiss = e.target.closest('.vip-bar__dismiss');
  if (!dismiss) return;
  var bar = dismiss.closest('.vip-bar');
  if (!bar) return;
  try { sessionStorage.setItem('lnVipBarDismissed', '1'); } catch (err) {}
  if (bar._vipTimer) { clearInterval(bar._vipTimer); bar._vipTimer = null; }
  bar.style.display = 'none';
});

function initVipBarRotation(bar) {
  var slides = bar.querySelectorAll('.vip-bar__slide');
  if (slides.length < 2) return; // nothing to rotate

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return; // first slide is already .is-active in the markup

  var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
  var index = 0;

  function tick() {
    slides[index].classList.remove('is-active');
    index = (index + 1) % slides.length;
    slides[index].classList.add('is-active');
  }
  function start() {
    if (bar._vipTimer) return;
    bar._vipTimer = setInterval(tick, interval);
  }
  function stop() {
    if (!bar._vipTimer) return;
    clearInterval(bar._vipTimer);
    bar._vipTimer = null;
  }

  start();
  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', start);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', function (e) {
    if (!bar.contains(e.relatedTarget)) start();
  });
}

document.querySelectorAll('.vip-bar').forEach(initVipBarRotation);

// The theme editor hot-swaps a section's DOM whenever its settings
// change in Customize (no full page reload), which orphans the rotation
// timer above -- the new markup gets none. Re-init on the section(s)
// that were just swapped in, and stop the old timer so it's not still
// ticking on a detached element.
document.addEventListener('shopify:section:load', function (e) {
  e.target.querySelectorAll('.vip-bar').forEach(initVipBarRotation);
});
document.addEventListener('shopify:section:unload', function (e) {
  e.target.querySelectorAll('.vip-bar').forEach(function (bar) {
    if (bar._vipTimer) { clearInterval(bar._vipTimer); bar._vipTimer = null; }
  });
});

(function () {
  var popup = document.querySelector('.vip-popup');
  if (!popup) return;
  try { if (sessionStorage.getItem('lnVipPopupShown')) return; } catch (err) {}

  function openPopup() {
    try { sessionStorage.setItem('lnVipPopupShown', '1'); } catch (err) {}
    popup.classList.add('is-open');
    document.removeEventListener('mouseleave', onMouseLeave);
    window.removeEventListener('scroll', onScroll);
  }
  function onMouseLeave(e) {
    if (e.clientY <= 0) openPopup();
  }
  function onScroll() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - doc.clientHeight;
    if (scrollable <= 0) return;
    if ((window.scrollY / scrollable) >= 0.5) openPopup();
  }
  document.addEventListener('mouseleave', onMouseLeave);
  window.addEventListener('scroll', onScroll, { passive: true });
})();

document.addEventListener('click', function (e) {
  if (!e.target.closest('.vip-popup__close') && !e.target.closest('.vip-popup__backdrop')) return;
  var popup = e.target.closest('.vip-popup');
  if (popup) popup.classList.remove('is-open');
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var popup = document.querySelector('.vip-popup.is-open');
  if (popup) popup.classList.remove('is-open');
});

(function () {
  var toggle = document.querySelector('.site-header__menu-toggle');
  var panel = document.querySelector('.nav-panel');
  if (!toggle || !panel) return;

  // .nav-panel is rendered inside header.liquid's output, which sits
  // inside .sticky-stack -- and .sticky-stack carries a CSS transform
  // (for the hide-on-scroll effect) that's always applied, not just
  // while hidden. A transform on any ancestor creates a new containing
  // block for position:fixed descendants, which breaks this panel's
  // full-viewport sizing: it collapses to the sticky-stack's own (much
  // shorter) height, forces an internal scrollbar, pins the VIP link to
  // the wrong box, and drops behind the header/bar in stacking order.
  // Move it to be a direct child of <body> so it's never inside a
  // transformed ancestor, regardless of what else the header does.
  if (panel.parentElement !== document.body) {
    document.body.appendChild(panel);
  }

  var sheet = panel.querySelector('.nav-panel__sheet');
  var closeBtn = panel.querySelector('.nav-panel__close');
  var overlay = panel.querySelector('.nav-panel__overlay');
  var lastFocused = null;

  function focusableEls() {
    return Array.prototype.slice.call(sheet.querySelectorAll('a[href], button:not([disabled])'));
  }

  function trapKeydown(e) {
    if (e.key === 'Escape') {
      closePanel();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusables = focusableEls();
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openPanel() {
    lastFocused = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('nav-panel-open');
    var focusables = focusableEls();
    if (focusables.length) focusables[0].focus();
    document.addEventListener('keydown', trapKeydown);
  }

  function closePanel() {
    if (!panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('nav-panel-open');
    document.removeEventListener('keydown', trapKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  toggle.addEventListener('click', function () {
    if (panel.classList.contains('is-open')) closePanel();
    else openPanel();
  });
  closeBtn.addEventListener('click', closePanel);
  overlay.addEventListener('click', closePanel);

  panel.querySelectorAll('.nav-panel__link--parent').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.nav-panel__item');
      var sublist = item.querySelector('.nav-panel__sublist');
      var expanded = item.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      sublist.style.maxHeight = expanded ? sublist.scrollHeight + 'px' : '';
    });
  });

  // Links inside the panel navigate to a new page -- reset state so a
  // bfcache restore never shows the panel open on the page you left.
  panel.querySelectorAll('a[href]').forEach(function (a) {
    a.addEventListener('click', closePanel);
  });
  window.addEventListener('pageshow', closePanel);
})();

// Scroll-reveal: sections fade up as they enter the viewport.
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  // .product-page is excluded: it holds the fixed-position sticky
  // add-to-cart bar, and a transform on an ancestor would break that
  // fixed positioning (creates a new containing block).
  var sections = document.querySelectorAll('main section:not(.product-page)');
  if (!sections.length) return;
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('is-revealed'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  sections.forEach(function (section) { observer.observe(section); });
})();

// Sticky header + VIP bar: hide on scroll down, reappear on scroll up.
(function () {
  var stack = document.querySelector('.sticky-stack');
  if (!stack) return;
  var lastY = window.scrollY;
  var ticking = false;
  var threshold = 8;
  var revealZone = 80;

  function onScroll() {
    var y = window.scrollY;
    var diff = y - lastY;
    if (Math.abs(diff) < threshold) { ticking = false; return; }
    if (y <= revealZone || diff < 0) {
      stack.classList.remove('is-hidden');
    } else {
      stack.classList.add('is-hidden');
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onScroll);
  }, { passive: true });
})();

// Shared Shopify Cart AJAX helpers -- used by both the cart drawer and
// the standalone cart page, so the two can't drift out of sync with
// each other the way the drawer and its own bugs already have.
function lnCartChangeLine(line, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  }).then(function (res) {
    if (!res.ok) throw new Error('cart change failed');
    return res.json();
  });
}

function lnFetchCartSection(sectionId) {
  return fetch('/cart?section_id=' + sectionId).then(function (res) { return res.text(); });
}

function lnUpdateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
    el.classList.toggle('is-empty', count === 0);
    el.classList.add('is-bumping');
    window.setTimeout(function () { el.classList.remove('is-bumping'); }, 260);
  });
}

// Cart drawer: panel open/close/focus-trap, plus every cart mutation
// (add, quantity change, remove). The drawer's own HTML always comes from
// Shopify's section-rendering endpoint (/cart?section_id=cart-drawer) --
// the exact same Liquid template this section renders on a full page
// load, so the two can never drift out of sync with each other.
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  var sheet = drawer.querySelector('.cart-drawer__sheet');
  var closeBtn = drawer.querySelector('.cart-drawer__close');
  var overlay = drawer.querySelector('.cart-drawer__overlay');
  var lastFocused = null;
  var busy = false;

  function focusableEls() {
    return Array.prototype.slice.call(sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'));
  }

  function trapKeydown(e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusableEls();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    var f = focusableEls();
    if (f.length) f[0].focus();
    document.addEventListener('keydown', trapKeydown);
  }

  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    document.removeEventListener('keydown', trapKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function refreshCartDrawer() {
    return lnFetchCartSection('cart-drawer').then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newInner = doc.querySelector('.cart-drawer__inner');
      var newTitle = doc.querySelector('.cart-drawer__title');
      var inner = drawer.querySelector('.cart-drawer__inner');
      var title = drawer.querySelector('.cart-drawer__title');
      if (newInner && inner) inner.innerHTML = newInner.innerHTML;
      if (newTitle && title) title.innerHTML = newTitle.innerHTML;
    });
  }

  function setBusy(state) {
    busy = state;
    drawer.classList.toggle('is-loading', state);
  }

  function updateLine(line, quantity) {
    if (busy) return;
    setBusy(true);
    lnCartChangeLine(line, quantity)
      .then(function (cart) {
        lnUpdateCartCount(cart.item_count);
        return refreshCartDrawer();
      })
      .then(function () { setBusy(false); })
      .catch(function () {
        // Cart state shown must never be allowed to go stale or wrong --
        // if the AJAX round trip fails for any reason, fall back to the
        // one place guaranteed to reflect the real server-side cart.
        window.location.href = '/cart';
      });
  }

  window.lnOpenCartDrawer = openDrawer;

  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.cart-drawer__remove');
    var qtyBtn = e.target.closest('.cart-drawer__qty-btn');
    var btn = removeBtn || qtyBtn;
    if (!btn) return;
    e.preventDefault();
    var line = btn.getAttribute('data-line');
    if (!line) return;
    if (removeBtn) {
      updateLine(line, 0);
      return;
    }
    var input = drawer.querySelector('.cart-drawer__qty-input[data-line="' + line + '"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 0;
    var next = qtyBtn.getAttribute('data-action') === 'increase' ? current + 1 : Math.max(0, current - 1);
    updateLine(line, next);
  });

  drawer.addEventListener('change', function (e) {
    var input = e.target.closest('.cart-drawer__qty-input');
    if (!input) return;
    var line = input.getAttribute('data-line');
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    updateLine(line, quantity);
  });

  // Add-to-cart forms: intercept via AJAX, but fall back to a normal
  // form submit (full page navigation) on any failure, so a broken
  // fetch never leaves the customer stuck with a dead button.
  //
  // Selector note: Shopify's {% form 'product', product %} tag does NOT
  // emit data-type="add-to-cart-form" -- it only ever set
  // class="shopify-product-form" and action="/cart/add". The previous
  // selector here never matched anything, so this handler never fired
  // and every add-to-cart click fell through to a real page navigation.
  // Confirmed by driving an actual headless browser against the real
  // rendered form before writing this fix.
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          lnUpdateCartCount(cart.item_count);
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.textContent = 'added';
            window.setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = originalText;
            }, 1400);
          }
          return refreshCartDrawer();
        })
        .then(openDrawer)
        .catch(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          form.submit();
        });
    });
  });
})();

// Standalone cart page: same plus/minus/remove interactions as the
// drawer, refreshing via the same section-rendering pattern instead of a
// full page reload.
(function () {
  var container = document.querySelector('.cart-page__inner');
  if (!container) return;
  var busy = false;

  function refresh() {
    return lnFetchCartSection('main-cart').then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newInner = doc.querySelector('.cart-page__inner');
      if (newInner) container.innerHTML = newInner.innerHTML;
    });
  }

  function setBusy(state) {
    busy = state;
    container.classList.toggle('is-loading', state);
  }

  function updateLine(line, quantity) {
    if (busy) return;
    setBusy(true);
    lnCartChangeLine(line, quantity)
      .then(function (cart) {
        lnUpdateCartCount(cart.item_count);
        return refresh();
      })
      .then(function () { setBusy(false); })
      .catch(function () { window.location.href = '/cart'; });
  }

  container.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.cart-drawer__remove');
    var qtyBtn = e.target.closest('.cart-drawer__qty-btn');
    var btn = removeBtn || qtyBtn;
    if (!btn) return;
    e.preventDefault();
    var line = btn.getAttribute('data-line');
    if (!line) return;
    if (removeBtn) {
      updateLine(line, 0);
      return;
    }
    var input = container.querySelector('.cart-drawer__qty-input[data-line="' + line + '"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 0;
    var next = qtyBtn.getAttribute('data-action') === 'increase' ? current + 1 : Math.max(0, current - 1);
    updateLine(line, next);
  });

  container.addEventListener('change', function (e) {
    var input = e.target.closest('.cart-drawer__qty-input');
    if (!input) return;
    var line = input.getAttribute('data-line');
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    updateLine(line, quantity);
  });
})();

// Variant picker: pill-styled radio buttons per option, matched against
// an embedded JSON blob of every variant (id, per-option values,
// availability, precomputed price strings) so switching is instant with
// no network round trip. Drives the hidden "id" input the add-to-cart
// form actually submits, the shown price and VIP price, per-pill
// sold-out styling (computed live against whatever else is currently
// selected, not just a static per-value flag), the URL's ?variant=
// param, and the gallery image if the chosen variant has its own.
function initVariantPicker(root) {
  var dataEl = root.querySelector('[data-product-variants]');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
  if (!variants || !variants.length) return;

  var idInput = root.querySelector('[data-product-variant-id]');
  var submitBtn = root.querySelector('[data-add-to-cart-btn]');
  var priceEl = root.querySelector('[data-product-price]');
  var priceCurrentEl = priceEl && priceEl.querySelector('[data-price-current]');
  var priceCompareEl = priceEl && priceEl.querySelector('[data-price-compare]');
  var vipCompact = root.querySelector('[data-vip-compact]');
  var vipCurrentEl = root.querySelector('[data-vip-current-price]');
  var vipMemberEl = root.querySelector('[data-vip-member-price]');
  var groups = Array.prototype.slice.call(root.querySelectorAll('.product-options__group'));
  if (!groups.length) return; // single-variant product -- nothing to wire up

  function getSelection() {
    return groups.map(function (group) {
      var checked = group.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(selection) {
    var matches = variants.filter(function (v) {
      return selection.every(function (val, i) {
        return val == null || v['option' + (i + 1)] === val;
      });
    });
    return matches.length ? matches[0] : null;
  }

  function updateAvailability() {
    var selection = getSelection();
    groups.forEach(function (group, gi) {
      group.querySelectorAll('input').forEach(function (radio) {
        var testSelection = selection.slice();
        testSelection[gi] = radio.value;
        var match = findVariant(testSelection);
        var pill = root.querySelector('label[for="' + radio.id + '"]');
        if (pill) pill.classList.toggle('is-unavailable', !match || !match.available);
      });
    });
  }

  function activateGalleryImage(imageId) {
    if (!imageId) return;
    var item = root.querySelector('.product-gallery__item[data-image-id="' + imageId + '"]');
    if (!item) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('.product-gallery__item'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.product-gallery__thumb'));
    var idx = items.indexOf(item);
    if (idx === -1) return;
    if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches) {
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    } else if (item.scrollIntoView) {
      item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  }

  function applyVariant(variant) {
    if (idInput) idInput.value = variant ? variant.id : '';

    if (submitBtn) {
      if (!variant) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'unavailable';
      } else if (!variant.available) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'sold out';
      } else {
        submitBtn.disabled = false;
        submitBtn.textContent = 'add to cart';
      }
    }

    if (!variant) return;

    // Update the sale/compare-at price spans individually (not
    // priceEl.textContent as a whole) -- priceEl's markup carries two
    // nested spans (see main-product.liquid) so a variant switch can
    // toggle the struck-through compare-at price on/off per variant
    // without clobbering that structure.
    if (priceCurrentEl) {
      priceCurrentEl.textContent = variant.price;
      priceCurrentEl.classList.toggle('ln-price-sale', !!variant.compare_at_price);
    }
    if (priceCompareEl) {
      priceCompareEl.hidden = !variant.compare_at_price;
      if (variant.compare_at_price) priceCompareEl.textContent = variant.compare_at_price;
    }

    if (vipCompact) {
      if (variant.vip_price) {
        vipCompact.style.display = '';
        if (vipCurrentEl) vipCurrentEl.textContent = variant.price;
        if (vipMemberEl) vipMemberEl.textContent = variant.vip_price;
      } else {
        vipCompact.style.display = 'none';
      }
    }

    activateGalleryImage(variant.image_id);

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    } catch (err) {}
  }

  groups.forEach(function (group) {
    group.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var label = group.querySelector('[data-option-value-label]');
      if (label) label.textContent = e.target.value;
      updateAvailability();
      applyVariant(findVariant(getSelection()));
    });
  });

  updateAvailability();
}

document.querySelectorAll('.product-page').forEach(initVariantPicker);

// Selling plan picker: subscription products (Simplee, Recharge, Bold,
// etc. all work the same way here) reject a bare variant ID with no
// selling_plan when the variant is subscription-only -- "Cart Error:
// Variant can only be purchased with a selling plan." main-product.liquid
// renders one radio pill per plan (plus a "one-time purchase" pill when
// the variant allows one) and a hidden name="selling_plan" input that
// this keeps in sync with whichever pill is checked. The hidden input is
// *disabled* rather than emptied when one-time purchase is selected --
// disabled fields are excluded from FormData entirely, matching how
// Shopify's cart API expects "no selling plan" to be expressed (an empty
// string is not equivalent and can itself be rejected).
function initSellingPlanPicker(root) {
  var picker = root.querySelector('[data-selling-plan-picker]');
  if (!picker) return;
  var radios = Array.prototype.slice.call(picker.querySelectorAll('[data-selling-plan-radio]'));
  if (!radios.length) return;
  var hiddenInput = root.querySelector('[data-selling-plan-input]');
  var priceEl = root.querySelector('[data-product-price] [data-price-current]');

  function apply(radio) {
    if (!radio) return;
    if (hiddenInput) {
      if (radio.value) {
        hiddenInput.value = radio.value;
        hiddenInput.disabled = false;
      } else {
        hiddenInput.disabled = true;
      }
    }
    var price = radio.getAttribute('data-selling-plan-price');
    if (price && priceEl) priceEl.textContent = price;
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () { apply(radio); });
  });

  var form = root.querySelector('form[action="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function () {
      // Last-resort guard: the variant requires a selling plan (server
      // rendered the hidden input with data-required) but nothing ended
      // up enabled -- force the first plan rather than let the request
      // go out with no selling_plan at all.
      if (hiddenInput && hiddenInput.disabled && hiddenInput.hasAttribute('data-required')) {
        var first = radios.filter(function (r) { return r.value; })[0];
        if (first) { first.checked = true; apply(first); }
      }
    });
  }
}

document.querySelectorAll('.product-page').forEach(initSellingPlanPicker);

// Product description accordion: if the rich-text description contains
// real heading tags (h1-h6), split it into an always-visible intro
// (everything before the first heading) plus one native <details> per
// heading, first one open. Headings are assumed top-level within the
// description, which is how Shopify's rich text editor structures them
// in the normal case. A description with no headings is left completely
// untouched.
//
// Bug fixed 2026-08-28: querySelectorAll('h1,...,h6') matches a heading
// ANYWHERE in the description, including one nested inside a wrapping
// element (e.g. a <div> from pasted content) rather than a direct child
// of `container`. The scan below only recognizes direct children as
// section starts -- so a nested heading passed the initial `headings.
// length` check but then produced zero top-level sections, and by the
// time that was discovered every one of the container's real children
// had already been moved (not copied) into a detached `intro` node that
// never made it back in. Net effect: an entire description could render
// as nothing, silently, with no error. Confirmed reproducible in a real
// browser DOM with a synthetic nested-heading description (before: 0
// characters of text left in the container; after the fix below: full
// text preserved) -- no product in the current catalog happens to have
// a nested heading today (swept every active product's description via
// the Admin API and found zero real heading tags at all, nested or not),
// so this wasn't actively blanking anything live, but the failure mode
// matches a reported "description missing entirely" bug exactly and is
// a real defect regardless of whether today's content happens to trigger
// it. Fix: scan a detached CLONE of the container instead of the live
// node -- nothing is ever removed from the real `container` until a
// valid accordion structure is fully built and ready to swap in, so a
// scan that finds zero usable top-level sections leaves the original,
// fully-visible content completely untouched.
// Added 2026-08-30: many merchant-written descriptions (this store included)
// don't use the rich text editor's actual heading styles at all -- they
// write a section title as a plain bolded paragraph instead, e.g.
// "<p><strong>Choose Your Signature Scent</strong></p>". Those never match
// the h1-h6 scan above, so the accordion silently no-ops and the whole
// description renders as one long unbroken block. Detect a paragraph as a
// pseudo-heading when essentially all of its text sits inside a <strong>/<b>
// run (a couple of stray characters are tolerated, e.g. a leading emoji like
// "🍓Strawberries N' Cream") and the bold text itself is short enough to
// read as a title rather than a sentence. A paragraph with real body text
// alongside the bold (or no bold at all) is left as ordinary body content.
function pseudoHeadingText(p) {
  if (p.tagName !== 'P') return null;
  var boldEls = p.querySelectorAll('strong, b');
  if (!boldEls.length) return null;
  var boldText = '';
  for (var i = 0; i < boldEls.length; i++) boldText += boldEls[i].textContent;
  boldText = boldText.replace(/\s+/g, '');
  if (!boldText) return null;
  if (boldText.length > 60) return null; // reads as a sentence, not a title
  var fullText = p.textContent.replace(/\s+/g, '');
  if (fullText.length - boldText.length > 3) return null; // real text outside the bold run
  return p.textContent.trim();
}

function initDescriptionAccordion(container) {
  var headings = container.querySelectorAll('h1, h2, h3, h4, h5, h6');
  var hasPseudoHeading = false;
  if (!headings.length) {
    container.querySelectorAll('p').forEach(function (p) {
      if (pseudoHeadingText(p)) hasPseudoHeading = true;
    });
  }
  if (!headings.length && !hasPseudoHeading) return;

  var source = container.cloneNode(true);
  var intro = document.createElement('div');
  intro.className = 'product-description__intro';
  var sections = [];
  var current = null;
  var node = source.firstChild;

  while (node) {
    var next = node.nextSibling;
    var isHeading = node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
    var isPseudoHeading = !isHeading && node.nodeType === 1 && !!pseudoHeadingText(node);
    if (isHeading || isPseudoHeading) {
      current = { heading: node, body: document.createElement('div') };
      current.body.className = 'product-description__body';
      sections.push(current);
    } else if (current) {
      current.body.appendChild(node);
    } else {
      intro.appendChild(node);
    }
    node = next;
  }

  if (!sections.length) return; // every match was nested, not top-level -- original is untouched

  // A pseudo-heading with nothing under it before the next heading (or the
  // end of the description) isn't really its own section -- e.g. a lead-in
  // line like "Choose Your Signature Scent" immediately followed by the
  // first real subsection, or a one-line spec like "Size: 4 oz (113 g)"
  // with nothing after it. Fold its text into the following section's body
  // (or the intro, if it was the last section) as a plain line instead of
  // giving it its own empty collapsible header.
  for (var s = sections.length - 1; s >= 0; s--) {
    var body = sections[s].body;
    var hasContent = false;
    for (var c = 0; c < body.childNodes.length; c++) {
      var cn = body.childNodes[c];
      var text = cn.textContent.replace(/ /g, '').trim();
      if (text || (cn.nodeType === 1 && cn.tagName !== 'P')) { hasContent = true; break; }
    }
    if (hasContent) continue;
    var line = document.createElement('p');
    line.textContent = sections[s].heading.textContent;
    var target = sections[s + 1] ? sections[s + 1].body : intro;
    target.insertBefore(line, target.firstChild);
    sections.splice(s, 1);
  }

  if (!sections.length) return; // everything folded away -- leave original untouched

  var wrapper = document.createElement('div');
  wrapper.className = 'product-description';
  if (intro.childNodes.length) wrapper.appendChild(intro);

  sections.forEach(function (section, i) {
    var details = document.createElement('details');
    details.className = 'product-description__section';
    if (i === 0) details.open = true;
    var summary = document.createElement('summary');
    summary.className = 'product-description__summary';
    summary.textContent = section.heading.textContent;
    details.appendChild(summary);
    details.appendChild(section.body);
    wrapper.appendChild(details);
  });

  container.replaceChildren(wrapper);
}

document.querySelectorAll('[data-product-description]').forEach(initDescriptionAccordion);

// Recently viewed products: localStorage-backed (Liquid has no access to
// it, so this section can't be server-rendered), most-recent-first,
// capped at 8, deduplicated (re-viewing a product moves it to the front
// instead of adding a second entry). Recording happens on every page that
// carries data-current-product-handle on <body> (see theme.liquid),
// regardless of whether the recently-viewed section is present -- so the
// history stays accurate even if a merchant temporarily removes it.
// Rendering only happens where the section IS present (product pages,
// the cart page -- never the cart drawer, deliberately: see
// sections/recently-viewed.liquid and templates/product.json/cart.json).
(function () {
  var STORAGE_KEY = 'lnRecentlyViewed';
  var MAX_ITEMS = 8;

  function readHandles() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (err) { return []; }
  }

  function recordView(handle) {
    var list = readHandles().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (err) {}
  }

  var currentHandle = document.body.getAttribute('data-current-product-handle');
  if (currentHandle) recordView(currentHandle);

  var section = document.querySelector('[data-recently-viewed]');
  var grid = section && section.querySelector('[data-recently-viewed-grid]');
  if (!grid) return;

  var handles = readHandles().filter(function (h) { return h !== currentHandle; }).slice(0, MAX_ITEMS);
  if (!handles.length) return; // stays hidden -- no placeholder, per spec

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function resizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function cardHtml(p) {
    var img = p.featured_image
      ? '<img src="' + resizedImage(p.featured_image, 700) + '" alt="' + escapeHtml(p.title) + '" width="700" height="875" loading="lazy">'
      : '';
    // Match snippets/product-card.liquid's compare-at treatment exactly --
    // this card exists only because Liquid can't read localStorage, but it
    // should still look identical to every server-rendered product card.
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var priceHtml = onSale
      ? '<span class="ln-price-compare">' + formatMoney(p.compare_at_price) + '</span><span class="ln-price-sale">' + formatMoney(p.price) + '</span>'
      : formatMoney(p.price);
    return '<a class="product-card" href="' + p.url + '"><div class="product-card__image">' + img + '</div>' +
      '<div class="product-card__info"><p class="product-card__title">' + escapeHtml(p.title) + '</p>' +
      '<div class="product-card__price">' + priceHtml + '</div></div></a>';
  }

  Promise.all(handles.map(function (handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  })).then(function (products) {
    // A stored handle can 404 if the product was since deleted or
    // unpublished -- skip it silently rather than breaking the whole row.
    var html = products.filter(Boolean).map(cardHtml).join('');
    if (!html) return; // every fetch failed -- stays hidden
    grid.innerHTML = html;
    section.hidden = false;
  });
})();
